import React from 'react';
import { formatCurrency } from 'utils';
import { blue, grey } from '@mui/material/colors';
import { Box, Stack, Typography } from '@mui/material';
import { Listing } from 'components/shared/TableListing';

import { FullReportResponse, ReportsListingViewModel } from '../../types';
import { getReportsListingConfig } from './reportsListingConfig';

interface Props {
  loading: boolean;
  list: FullReportResponse['list'];
}

export const FullReportsListing = ({ loading, list }: Props) => {
  const columns = getReportsListingConfig();

  return (
    <Listing<ReportsListingViewModel>
      tableData={[]}
      loading={loading}
      columns={columns}
      staticSettings={{ allGroupsOpen: true }}
      groups={list.map(group => ({
        name: group.name,
        data: group?.data ?? [],
        beforeGroup: {
          render: () => (
            <Stack direction="row" gap="0.5rem" alignItems="center">
              <Typography>{group.meta.label}</Typography>

              <Box
                sx={{
                  display: 'flex',
                  width: '1.5rem',
                  height: '1.5rem',
                  alignItems: 'center',
                  borderRadius: '100%',
                  justifyContent: 'center',
                  backgroundColor: grey[300],
                }}
              >
                <Typography>{group?.data?.length ?? 0}</Typography>
              </Box>
            </Stack>
          ),
          cellStyles: {
            backgroundColor: grey[50],
          },
        },
        afterGroup: {
          render: () => (
            <Stack direction="row" gap="0.5rem">
              <Typography>Subtotal</Typography>
              <Typography>{formatCurrency(group.meta.invoiceSubTotal, true)}</Typography>
            </Stack>
          ),
          cellStyles: {
            backgroundColor: blue[100],
          },
        },
      }))}
    />
  );
};
